import React from 'react'

const EnableDisableTag = ({ enabled = false }) => {
  const tagClasses = enabled ? 'bg-green-150 text-gray-700' : 'bg-gray-200 text-gray-700'
  return (
    <div className={`rounded-xl py-1 px-3 h-7 font-semibold flex justify-center items-center gap-1 ${tagClasses}`}>
      <span className={`block rounded-3xl p-1 bg-gray-700 ${enabled ? 'bg-green-500' : 'bg-gray-700'}`}></span>
      { enabled ? 'Enabled' : 'Disabled' }
    </div>
  )
}

export default EnableDisableTag